import React from "react";
import { useBreakpoint } from "../../hooks/useBreakpoint";

import CollapsibleWrapper from "../../components/shared/collapsibleWrapper";
import CourseInformation from "./courseInformation";
import Image from "../../components/image";

import Tick from "../../images/icons/tick.inline.svg";
import CertificationSignature from "../../images/online/certification-signature.png";
import MountainIllustration from "../../images/illustrations/Mountain_illustration_gray.inline.svg";
import AnemoneIllustration from "../../images/illustrations/Anemone-Illustration-dark.inline.svg";
import URLogo from "../../images/ur-logo-white.inline.svg";
import BWLogo from "images/bw-light-logo.inline.svg";

const ConditionalWrapper = ({ condition, children }) =>
  children ? (
    condition ? (
      <div className="md:basis-1/2">{children}</div>
    ) : (
      children
    )
  ) : null;

const CourseSection = ({
  courseIntroduction,
  skillsYouAcquire,
  isCourseForMe,
  courseCertificateDescription,
  genDetails,
  testimonials,
  coursePrice,
  programCode,
  isBushwiseProgram,
  certificationTitle = "Earn your certification"
}) => {
  const breakpoint = useBreakpoint();
  return (
    <section className="flex flex-col justify-center">
      <CourseInformation
        genDetails={genDetails}
        testimonials={testimonials}
        programCode={programCode}
        coursePrice={coursePrice}
        isBushwiseProgram={isBushwiseProgram}
      />
      <div className="relative overflow-hidden tab-content">
        <div className="relative z-10 w-11/12 md:gvi-container my-9 md:my-28 mx-auto">
          <div className="flex flex-col md:flex-row md:gap-14 text-black-lighter planet:text-gray-generic text-mob md:text-base">
            <ConditionalWrapper condition={breakpoint !== "xs"}>
              <div className="course-intro order-1">
                <div
                  className="h2 pb-3 md:pb-5 border-b planet:border-gray-light"
                  dangerouslySetInnerHTML={{ __html: "Course introduction" }}
                />
                <CollapsibleWrapper
                  desc={courseIntroduction}
                  descStyle="tab-content_html pt-4 md:pt-6"
                  btnStyle="underline underline-offset-2 pt-3 md:hidden"
                  visibleLength={breakpoint === "xs" ? 350 : 70}
                  readMoreAdditionalStyle={"md:line-clamp-none"}
                  type={"mobile-only"}
                  displayFullDesc={breakpoint !== "xs"}
                />
              </div>

              <div className="course-info mt-12 md:mt-14 order-3">
                <div
                  className="h2 pb-3 md:pb-5 border-b planet:border-gray-light"
                  dangerouslySetInnerHTML={{ __html: isCourseForMe.heading }}
                />
                <div
                  className="pt-4 md:pt-6 tab-content_html"
                  dangerouslySetInnerHTML={{ __html: isCourseForMe.text }}
                />
              </div>
            </ConditionalWrapper>

            <ConditionalWrapper condition={breakpoint !== "xs"}>
              <div className="course-skills mt-12 md:mt-0 order-2">
                <div
                  className="h2 pb-3 md:pb-5 border-b planet:border-gray-light"
                  dangerouslySetInnerHTML={{ __html: skillsYouAcquire.heading }}
                />
                <div className="pt-4 md:pt-6">
                  <div
                    className="mb-4 w-5/6 md:w-auto tab-content_html"
                    dangerouslySetInnerHTML={{ __html: skillsYouAcquire.text }}
                  />
                  {skillsYouAcquire?.skillsYoullAcquire?.map((skill, i) => (
                    <label className="py-2 flex items-start" key={i}>
                      <input
                        type="checkbox"
                        className="opacity-0 absolute"
                        checked={true}
                      />
                      <div className="w-[18px] h-[18px] bg-transparent border border-black-lighter planet:border-gray-generic rounded-xxs flex shrink-0 justify-center items-center mt-[3px] mr-5 tick stroke-black-lighter planet:stroke-gray-generic">
                        <Tick className="block" />
                      </div>
                      {skill.skill}
                    </label>
                  ))}
                </div>
              </div>

              <div className="course-certification order-4">
                <div
                  className="h2 pb-3 md:pb-5 border-b planet:border-gray-light mt-12 md:mt-14"
                  dangerouslySetInnerHTML={{
                    __html: certificationTitle
                  }}
                />

                <div className="flex justify-between gap-2 pt-4 md:pt-6">
                  <Image
                    imageAlt="Certification signature"
                    image={""}
                    imageClass="rounded-xxs w-[55%] md:w-full h-[30vw] md:h-auto object-cover"
                    sourceUrl={CertificationSignature}
                  />
                  <div className="flex items-center justify-center rounded-xxs px-4 py-8 md:p-7 bg-black-lighter planet:bg-gray-darker">
                    {isBushwiseProgram ? (
                      <BWLogo className="w-full md:w-full h-14" />
                    ) : (
                      <URLogo className="w-full h-full" />
                    )}
                  </div>
                </div>
                <div
                  className="pt-4 md:pt-6 tab-content_html"
                  dangerouslySetInnerHTML={{
                    __html: courseCertificateDescription
                  }}
                />
              </div>
            </ConditionalWrapper>
          </div>
        </div>
        <div className="absolute w-full h-full" />
        <MountainIllustration className="absolute z-0 left-0 -bottom-[16vw] w-[32vw] h-[32vw] planet:hidden hidden md:block xl:w-2/5" />
        <AnemoneIllustration className="absolute z-0 opacity-10 -left-[20vw] -bottom-[45vw] hidden planet:md:block" />
      </div>
    </section>
  );
};

export default CourseSection;
